import React from 'react';
import ShowEntityData from '../../../../Elements/ShowEntityData';
import ClientInvoiceAdminItem from '../../../../Domain/ClientInvoiceAdminItem';
import ClientInvoiceService from '../../../../Services/ClientInvoiceService';

export default class ClientInvoiceDetailsInfoTab extends React.Component {
  static defaultProps = {
    clientInvoiceId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      clientInvoiceId: props.clientInvoiceId,
    };
  }

  render() {
    return (
      <ShowEntityData
        itemId={this.state.clientInvoiceId}
        type={ClientInvoiceAdminItem}
        serviceGetByIdFunction={ClientInvoiceService.GetByInvoiceId}
      />
    );
  }
}
